import ActionTypes from 'redux/ActionTypes';

const initialState = {
	event: {},
	common: {},
};

const localize = (state = initialState, { type, payload }) => {
	switch (type) {
		case ActionTypes.SET_LOCALIZE:
			return { ...state, [payload.key]: payload.data };
		default:
			return state;
	}
};

export default localize;
